import React, { Component } from 'react'
import { CommonValidationMessages } from '../../../utils/Messages';
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import OtherFormsServices from '../../../services/axiosServices/apiServices/OtherFormsServices';
import TransactionStockServices from '../../../services/axiosServices/apiServices/TransactionStockServices';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { AgGridReact } from "ag-grid-react";
import { BackToStorePopup } from './BackToStoreTable';
import { decryptAES } from '../../../utils/Encryption';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import moment from 'moment';
import { permission } from '../../../utils/enums/ValidationMessage';

export default class BackToStore extends Component {
    constructor(props) {
        super(props)
        this.accountTransactionServices = new AccountTransactionServices();
        this.SwalServices = new SwalServices();
        this.otherFormsServices = new OtherFormsServices();
        this.transactionStockServices = new TransactionStockServices();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            isModalOpen: false,
            isModalOpenForEditItem: false,
            isTable2Expanded: false,
            isShown: false,
            rowData: [],
            colDefs: [],
            invoiceRowData: [],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            idUser: 0,
            table2Data: [],
            table2ColDefs: [],
            firstList: [],
            secondList: [],
            tempSecondList: [],
            open: false,
            itemRowData: [],
            transferObject: {
                idTransferLocationInward: 0,
                inwardNo: '001',
                updateStatus: 0,
                date: new Date().toISOString(),
                referenceNo: '',
                //refDate: '',
                transferList: [],
                idTransferLocation: 0,
                transferFromList: [],
                idPlantLocation: '',
                transferToList: [],
                idPlantLocationToTransfer: '',
                remarks: '',
                //idPlantLocationToTransfer: 0,
                referenceDate: '',
                deleteItemsList: [],
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                transferNo: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "product"
                        ),
                    },
                ],
            },
        }
    }

    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        this.resetDetailsFields();
        this.setState({ isModalOpen: true, open: false }, () => {
            this.usp_Transaction_TransferLocationSelectTransferNo();
            this.getPlantList();
        })
    };

    setOpenModel = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };
    closePopup = () => {
        this.setState({ isModalOpen: false, });
    };

    back = () => {
        this.setState({ open: !this.state.open });
    }

    handleChange = (event, name, field) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.transferObject;
        details[name] = value;
        this.setState({ transferObject: details });
    }

    handleChangeForDropdown = (event, name, field) => {
        let details = this.state.transferObject;
        let value = event.value;
        details[name] = value;
        this.setState({ transferObject: details }, () => {
            if (name === 'idTransferLocation') {
                this.usp_Transaction_TransferLocationSelectByIdForInward()
            }
        });
    }

    toggleExpandCollapseTable = (tableNumber) => {
        this.setState((prevState) => {
            if (tableNumber === 2) {
                return { isTable2Expanded: !prevState.isTable2Expanded };
            } else if (tableNumber === 3) {
                return { isTable3Expanded: !prevState.isTable3Expanded };
            } else {
                return {};
            }
        });
    };

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        this.usp_Transaction_TransferLocationInwardSelectById(event.data.idTransferLocationInward);
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState
        });
    };

    componentDidMount = () => {
        let params = new URLSearchParams(window.location.search);
        let id = params.get("id")
        if (id) {
            let urlId = decryptAES(id)
            if (urlId) {
                if (urlId != null) {
                    this.setState({ urlId: urlId });
                }
            }
        }

        let prop = getAuthProps()
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser ? prop.idUser : 0, entryBy: prop.name, companyName: prop.companyName }, () => {
                this.procSelectAllRecordsSP();
                this.usp_Transaction_TransferLocationSelectTransferNo();
                this.getPlantList();
            });
        }
    }

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Back to Store",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth(key) !== undefined ? this.getColumnWidth(key) : window.innerWidth * 0.06,
                            width: this.getPinnedColumnWidth(key) !== undefined ? this.getPinnedColumnWidth(key) : window.innerWidth * 0.05,
                            //pinned: ["sR.No", "jobWorkNo", "jobWorkInwardDate", "jobWorkFrom", "invoiceNo"].includes(key) ? "left" : undefined,
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            hide: ["idTransferLocationInward"].includes(key) ? true : false,
                            valueGetter: (params) => params.data[key],
                            valueFormatter: key.toLowerCase().includes("date") ? (params) => {
                                if (!params.value) return "";
                                const date = new Date(params.value);
                                return moment(date).format('DD-MM-YYYY')
                            } : undefined,
                        }));
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs,
                            caption: "Back to Store",
                            colName: colName
                        }, () => {
                            this.setPermissions(permissions);
                            this.procSelectAllRecord2GridviewSP(id);
                            if (this.state.urlId) {
                                this.openPopUpFromURLId(this.state.urlId)
                            }
                        });
                    } else {
                        this.setPermissions(permissions);
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                            this.gridApi.showNoRowsOverlay();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    getColumnWidth = (key) => {
        const colwidth = {
            // "invoiceDate": window.innerWidth * 0.08,
            // "vendor": window.innerWidth * 0.2,
            // "gatePassNo": window.innerWidth * 0.06,
            // "totalQty": window.innerWidth * 0.06,
            // "totalAmt": window.innerWidth * 0.06,
            // "extraCharges": window.innerWidth * 0.06,
            // "discount": window.innerWidth * 0.06,
            // "taxAmt": window.innerWidth * 0.06,
            // "finalAmt": window.innerWidth * 0.06,
            // "approvalStatus": window.innerWidth * 0.08,
        }
        return colwidth[key]
    }
    getPinnedColumnWidth = (key) => {
        const colwidth = {
            // "sR.No": window.innerWidth * 0.05,
            // "jobWorkNo": window.innerWidth * 0.09,
            // "jobWorkInwardDate": window.innerWidth * 0.08,
            // "jobWorkFrom": window.innerWidth * 0.08,
            // "invoiceNo": window.innerWidth * 0.06,
        }
        return colwidth[key]
    }

    procSelectAllRecord2GridviewSP = (id) => {
        let request = {
            id: id,
            formname: "Back to Store",
            allowToRateVisible: 1,
        }
        if (id > 0) {
            this.accountTransactionServices.procSelectAllRecord2GridviewSP(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    const dynamicData = response.responseItem.responseContent;
                    if (dynamicData.length > 0) {
                        const dynamicColDefs = Object.keys(dynamicData[0]).map((key) => ({
                            field: key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth2(key) !== undefined ? this.getColumnWidth2(key) : window.innerWidth * 0.06,
                            filter: true,
                            floatingFilter: true,
                            flex: 1,
                        }));
                        this.setState({
                            table2Data: dynamicData,
                            table2ColDefs: dynamicColDefs,
                            isTable2Expanded: true
                        });
                    }
                }
            });
        }
    }

    getColumnWidth2 = (key) => {
        const colwidth = {
            "drawingNo": window.innerWidth * 0.11,
            "itemName": window.innerWidth * 0.2,
            "quantity": window.innerWidth * 0.06,
            "returnQuantity": window.innerWidth * 0.06,
            "itemRemarks": window.innerWidth * 0.06,
        }
        return colwidth[key]
    }

    usp_Transaction_TransferLocationSelectTransferNo = () => {
        let request = [this.state.idCompany, this.state.transferObject.updateStatus, this.state.transferObject.idTransferLocationInward];
        this.otherFormsServices.usp_Transaction_TransferLocationSelectTransferNo(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                if (data.length > 0) {
                    data = data.map((x) => ({
                        value: x.idTransferLocation,
                        label: x.transferNo + ' - ' + x.transferFromPlant, //+ ' - ' + x.date,
                    }));
                }
                let transferObject = this.state.transferObject;
                transferObject.transferList = data;
                transferObject.idTransferLocation = transferObject.idTransferLocation;
                this.setState({ transferObject: transferObject }, () => {
                });
            }
        });
    }

    getPlantList = () => {
        this.transactionStockServices.usp_Master_PlantSelect(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                if (data.length > 0) {
                    data = data.map((x) => ({
                        value: x.idPlant,
                        label: x.plantDetails,
                    }));
                }
                let transferObject = this.state.transferObject;
                transferObject.transferFromList = data;
                transferObject.transferToList = data;
                this.setState({ transferObject: transferObject }, () => {
                });
            }
        });
    }

    usp_Transaction_TransferLocationSelectByIdForInward = () => {
        //let request = [];
        if (this.state.transferObject.idTransferLocation > 0) {
            this.otherFormsServices.usp_Transaction_TransferLocationSelectByIdForInward(this.state.transferObject.idTransferLocation).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let res1 = response.responseItem.responseContent[0][0];
                    let res2 = response.responseItem.responseContent[1];
                    // if (data.length > 0) {
                    //     data = data.map((x) => ({
                    //         value: x.idTransferLocation,
                    //         label: x.transferNo + ' - ' + x.transferFromPlant + ' - ' + x.date,
                    //     }));
                    // }
                    let transferObject = this.state.transferObject;
                    transferObject.date = moment(res1.date).format('YYYY-MM-DD');
                    transferObject.idPlantLocation = res1.idPlantLocation;
                    //transferObject.transferTo = res1.idPlantLocationToTransfer;
                    transferObject.referenceNo = res1.referenceNo;
                    transferObject.remarks = res1.remarks;
                    transferObject.idPlantLocationToTransfer = res1.idPlantLocationToTransfer;
                    transferObject.referenceDate = res1.referenceDate;
                    res2?.map((x, key) => {
                        x.keyId = key + 1;
                        x.returnQuantity = x.pendingQty;
                    });
                    this.setState({ transferObject: transferObject, itemRowData: res2 }, () => {
                    });
                }
            });
        }
    }

    submit = () => {
        // synchronous re-entry guard: setState({isLoading}) is async, so a fast double-click
        // can fire submit twice before the Save button re-renders as the spinner
        if (this.isSubmitting) {
            return;
        }
        if (this.state.itemRowData.length === 0) {
            this.SwalServices.Error("Please add item details.");
            return;
        }

        let details = this.state.transferObject;

        let requestData = {

            idTransferLocationInward: details.idTransferLocationInward,
            date: details.date,
            idTransferLocation: details.idTransferLocation,
            idFromPlant: details.idPlantLocation,
            idInwardPlant: details.idPlantLocationToTransfer,
            remarks: details.remarks,
            isUpdated: 1,
            updatedDate: new Date().toISOString(),
            u_IDUser: this.state.idUser,
            idCompany: this.state.idCompany,
            e_Date: new Date().toISOString(),
            e_IDUser: this.state.idUser,
            idFinancialYear: null,
            itemList: [],
            deleteItemsList: details.deleteItemsList,

        };
        this.isSubmitting = true;
        this.setState({ isLoading: true })
        let itemRowData = this.state.itemRowData;
        itemRowData?.map((x) => {
            x.idTransferLocationInwardDetails = x.idTransferLocationInwardDetails ? x.idTransferLocationInwardDetails : 0;
        });
        requestData.itemList = itemRowData;

        //requestData.itemList2 = this.state.itemList2;
        this.otherFormsServices
            .usp_Transaction_TransferLocationInwardInsertUpdate(requestData)
            .then((response) => {
                if (response.statusCode === 200 && response.responseItem !== null) {
                    let dynamicData = response.responseItem.responseContent;
                    if (dynamicData?.errorType === "Exists") {
                        this.SwalServices.Warning(dynamicData.errorMessage);
                        this.setState({ isLoading: false })
                    } else {
                        if (details.updateStatus === 1) {
                            this.SwalServices.Success("Updated successfully.");
                        } else {
                            this.SwalServices.Success("Saved successfully.");
                        }
                        this.setState({ isLoading: false })
                        this.resetDetailsFields();
                        //this.resetItemDetails();
                        //this.resetWorkObjectDetails();
                        //this.resetWorkPlanningObject();
                        this.setState({ isModalOpen: false }, () => {
                            this.procSelectAllRecordsSP();
                        });
                    }
                } else {
                    this.setState({ isLoading: false })
                    this.setState({ isModalOpen: false }, () => {
                        this.SwalServices.Error(response.message);
                        this.procSelectAllRecordsSP();
                    });
                }
            })
            .catch((err) => {
                this.SwalServices.Error("Something went wrong: " + err.message);
            })
            .finally(() => {
                this.isSubmitting = false;
                this.setState({ isLoading: false });
            });
    };

    resetDetailsFields = () => {
        let transferObject = this.state.transferObject;
        transferObject.idTransferLocationInward = 0;
        transferObject.inwardNo = '001';
        transferObject.updateStatus = 0;
        transferObject.date = moment(new Date().toISOString()).format('YYYY-MM-DD');
        transferObject.referenceNo = '';
        //refDate= '';
        //transferObject.transferList = [];
        transferObject.idTransferLocation = 0;
        //transferObject.transferFromList = [];
        transferObject.idPlantLocation = '';
        //transferObject.transferToList = [];
        transferObject.idPlantLocationToTransfer = '';
        transferObject.remarks = '';
        transferObject.referenceDate = '';
        transferObject.deleteItemsList = [];

        this.setState({ transferObject: transferObject, itemRowData: [] })
    }

    usp_Transaction_TransferLocationInwardSelectById = (id) => {
        if (id > 0) {
            this.otherFormsServices.usp_Transaction_TransferLocationInwardSelectById(id).then((response) => {
                if (response.statusCode === 200 && response.responseItem !== null) {
                    let res = response.responseItem.responseContent[0][0];
                    let res2 = response.responseItem.responseContent[1];

                    let transferObject = this.state.transferObject;

                    transferObject.idTransferLocationInward = res.idTransferLocationInward;
                    transferObject.inwardNo = res.inwardNo;
                    transferObject.updateStatus = 1;
                    transferObject.date = moment(res.date).format('YYYY-MM-DD');
                    transferObject.referenceNo = res.referenceNo;
                    //refDate= '';
                    //transferObject.transferList = [];
                    transferObject.idTransferLocation = res.idTransferLocation;
                    //transferObject.transferFromList = [];
                    transferObject.idPlantLocation = res.idFromPlant;
                    //transferObject.transferToList = [];
                    transferObject.idPlantLocationToTransfer = res.idInwardPlant;
                    transferObject.remarks = res.remarks;
                    transferObject.referenceDate = moment(res.date).format('YYYY-MM-DD');//moment(res.referenceDate).format('YYYY-MM-DD');
                    transferObject.deleteItemsList = [];

                    let itemListRowData = res2;
                    // res2?.map((x) => {
                    //     let object = {
                    //         idTransferLocationDetails: x.idTransferLocationDetails,
                    //         idItemName: x.idItem,
                    //         itemName: x.itemName,
                    //         drawingNo: x.drawingNo,
                    //         stock: x.stock,
                    //         quantity: x.quantity,
                    //         remarks: x.itemRemarks,
                    //     };
                    //     itemListRowData.push(object);
                    // });
                    itemListRowData?.map((x, key) => {
                        x.keyId = key + 1;
                    });
                    //transferObject.itemList = itemListRowData;
                    //let itemData2 = [];
                    // if (transferObject.idFrom === 2) {
                    //     itemData2 = res3;
                    // }
                    this.setState({
                        transferObject: transferObject,
                        itemRowData: itemListRowData,
                        //itemList2: itemData2,
                        isModalOpen: true,
                    }, () => {
                        this.usp_Transaction_TransferLocationSelectTransferNo();
                    });
                }
            });
        }
    };

    render() {
        return (
            <div className='back-to-store'>
                <div className='data-display'>
                    <div className='data-display-inner relative'>
                        <ButtonGrp buttons={['add', 'print']}
                            onClickHandlers={{
                                add: () => this.openPopUpForAddingItem(),
                                // update: () => this.openPopUpForUpdateItem(),
                                print: this.handlePrint,
                            }}
                        />
                        <BackToStorePopup
                            isModalOpen={this.state.isModalOpen}
                            setOpenModel={this.setOpenModel.bind(this)}
                            transferObject={this.state.transferObject}
                            itemObject={this.state.itemObject}
                            handleChange={this.handleChange.bind(this)}
                            close={this.closePopup.bind(this)}
                            submit={this.submit.bind(this)}
                            validState={this.state.validState}
                            itemRowData={this.state.itemRowData}
                            handleChangeForDropdown={this.handleChangeForDropdown.bind(this)}
                            // addWorkOrder={this.addWorkOrder.bind(this)}
                            // addProduct={this.addProduct.bind(this)}
                            back={this.back.bind(this)}
                            open={this.state.open}
                            isLoading={this.state.isLoading}
                        // firstList={this.state.firstList}
                        // secondList={this.state.secondList}
                        // handleCellClickfirstList={this.handleCellClickfirstList.bind(this)}
                        // handleCellClickItemList={this.handleCellClickItemList.bind(this)}
                        // onSelectionChanged={this.onSelectionChanged.bind(this)}
                        />
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 300px)" }}>
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Back to store</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    onGridReady={this.onGridReady}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                />
                            </div>
                        </div>

                        <div className="table w-full mt-[10px] bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className={`table-2 w-full px-[1px] rounded-[5px] ${this.state.isTable2Expanded ? 'h-[448px]' : 'h-[0]'}`}>
                                <div className="table-inner" onClick={() => this.toggleExpandCollapseTable(2)}>
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Details</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.table2Data}
                                    columnDefs={this.state.table2ColDefs}
                                    rowHeight={this.state.rowHeight}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onGridReady={this.onGridReady}
                                />
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        )
    }
}